export class TimeSpent {
  constructor(callback) {
    // see: http://backoffcalculator.com/?interval=5&attempts=30&rate=1.2
    this.maxIterations = 30;
    this.startIntervalSec = 5;
    this.currentIntervalSec = 5;
    this.currentIteration = 0;
    this.exponent = 1.2;
    this.callback = callback;
    this.totalElapsedSec = 0;
    this.currentTimeoutId = null;

    this.isStarted = true;
    this.visibilityPaused = false;
  }

  start() {
    this.visibilityPaused = false;
    this.handler = this.visibilityEventHandler.bind(this);
    document.addEventListener("visibilitychange", this.handler, false);

    this.startInternal();
  }

  stop() {
    this.stopInternal();
    // console.log("removing event listener");
    document.removeEventListener("visibilitychange", this.handler, false);
  }

  startInternal() {
    // console.log("startInternal");
    if (this.currentTimeoutId) {
      clearTimeout(this.currentTimeoutId);
      this.currentTimeoutId = null;
    }

    this.currentIteration = 0;
    this.currentIntervalSec = this.startIntervalSec;
    this.iterationStartTime = Date.now();
    this.isStarted = true;

    this.currentTimeoutId = setTimeout(
      this.timerFiredCallback.bind(this),
      this.currentIntervalSec * 1000
    );
  }

  stopInternal() {
    // console.log("stopInternal");
    if (this.currentTimeoutId) {
      clearTimeout(this.currentTimeoutId);
      this.currentTimeoutId = null;
    }

    const intervalSec = (Date.now() - this.iterationStartTime) / 1000;

    this.callback({
      iteration: this.currentIteration,
      intervalSec,
      totalElapsedSec: this.totalElapsedSec,
    });
  }

  visibilityEventHandler() {
    if (document.hidden) {
      // console.log("document hidden, stopping");
      this.visibilityPaused = true;
      this.stopInternal();
    } else if (this.visibilityPaused === true) {
      // console.log("document visible, restarting");
      this.visibilityPaused = false;
      this.startInternal();
    }
  }

  timerFiredCallback() {
    this.totalElapsedSec += this.currentIntervalSec;

    this.callback({
      iteration: this.currentIteration,
      intervalSec: this.currentIntervalSec,
      totalElapsedSec: this.totalElapsedSec,
    });

    this.currentIteration++;
    this.currentIntervalSec =
      this.startIntervalSec * Math.pow(this.exponent, this.currentIteration);

    if (this.currentIteration <= this.maxIterations) {
      this.iterationStartTime = Date.now();
      this.currentTimeoutId = setTimeout(
        this.timerFiredCallback.bind(this),
        this.currentIntervalSec * 1000
      );
    } else {
      this.stop();
    }
  }
}
